var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons / Alert"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 65",
    cx: 30,
    cy: 30,
    r: 21,
    fill: "#FFB649",
    fillOpacity: 0.2,
    stroke: "#FFB649",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 66",
    cx: 30,
    cy: 40,
    r: 3,
    fill: "#FFB649"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 223",
    d: "M27.1762 19.9948C27.0806 18.3701 28.3724 17 30 17C31.6276 17 32.9194 18.3701 32.8238 19.9948L32.1174 32.0035C32.0515 33.1246 31.1231 34 30 34C28.8769 34 27.9485 33.1246 27.8826 32.0035L27.1762 19.9948Z",
    fill: "#FFB649"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 67",
    cx: 8.5,
    cy: 8.5,
    r: 4.5,
    fill: "#FFB649",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 68",
    cx: 48,
    cy: 8,
    r: 3,
    fill: "#FFB649",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 70",
    cx: 49,
    cy: 52,
    r: 2,
    fill: "#FFB649",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 69",
    cx: 55,
    cy: 14,
    r: 2,
    fill: "#FFB649",
    fillOpacity: 0.4
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.a5f1b082264a6ac76443c38999881559.svg";
export { ForwardRef as ReactComponent };